import { useState, useEffect } from 'react';
import { adminApi } from '../../services/adminApi';

export default function OrgTimelineTab({ orgId }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    adminApi.getOrgTimeline(orgId)
      .then(data => setEvents(Array.isArray(data) ? data : []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [orgId]);

  if (loading) return <div className="py-8 text-center text-gray-500">Loading timeline...</div>;
  if (events.length === 0) return <div className="py-8 text-center text-gray-500">No timeline events found.</div>;

  return (
    <div className="relative pl-8 py-4">
      <div className="absolute left-3 top-0 bottom-0 w-0.5 bg-gray-200" />
      {events.map((event, idx) => (
        <div key={idx} className="relative mb-6">
          <div className="absolute -left-5 w-3 h-3 rounded-full bg-blue-500 border-2 border-white shadow" />
          <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm font-semibold text-gray-800">{event.eventType || event.type}</span>
              <span className="text-xs text-gray-500">
                {event.timestamp ? new Date(event.timestamp).toLocaleString() : event.date || ''}
              </span>
            </div>
            <p className="text-sm text-gray-600">{event.description || event.message || JSON.stringify(event)}</p>
            {event.user && <p className="text-xs text-gray-400 mt-1">by {event.user}</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
